import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import OverviewChallenge from '../Components/studies/OverviewChallenge'
import HiringProcessFAQ from '../Components/studies/HiringProcessFAQ'
import CaseStudyBanner from '../Components/studies/CaseStudyBanner'
import { Helmet } from "react-helmet-async";

function CaseStudiesDetail() {
    return (
        <div>
            <Helmet>
    <title>
        US Midwest Community Bank Lending Modernization | Mobikode Case Study
    </title>

    <meta
        name="description"
        content="Explore how Mobikode helped a US Midwest Community Bank modernize lending operations through consulting-led transformation, reducing processing time, improving efficiency, and delivering significant cost savings."
    />

    <meta
        name="keywords"
        content="Mobikode Case Study, Community Bank Case Study, Banking Technology Case Study, Lending Modernization, Lending Operations, Digital Lending Transformation, Banking Consulting, Loan Processing Automation, Banking Digital Transformation, Financial Services Technology, Lending Technology Solutions"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/case-studies/us-midwest-community-bank-lending-modernization"
    />

    <meta
        property="og:title"
        content="US Midwest Community Bank Lending Modernization | Mobikode Case Study"
    />

    <meta
        property="og:description"
        content="See how consulting-led modernization helped a US Midwest Community Bank transform lending operations, improve processing efficiency, enhance customer experience, and achieve measurable cost savings."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/case-studies/us-midwest-community-bank-lending-modernization"
    />

    <meta
        property="og:type"
        content="article"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/insights/bg4.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="US Midwest Community Bank Lending Modernization | Mobikode Case Study"
    />

    <meta
        name="twitter:description"
        content="Discover how Mobikode's consulting-led modernization approach transformed lending operations for a US Midwest Community Bank."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/insights/bg4.png"
    />
</Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/insights/bg4.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    {/* Responsive Gradient: Mobile par niche se upar, Desktop par left se right */}
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                {/* Content Container */}
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] lg:max-w-[900px] mt-auto md:mt-0">
                        <p className="text-[#FFFFFF] max-w-[1200px] w-full text-[20px] md:text-[30px] leading-[1.4] md:leading-[34px] lg:leading-[54px] font-sora font-[600] tracking-wider text-left opacity-90 lg:opacity-100">
                            US Midwest Community Bank Transforms Lending Operations Through Consulting-led Modernization
                        </p>
                    </div>
                </div>
            </section>
            <OverviewChallenge />
            <HiringProcessFAQ />
            <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] lg:pb-[100px] pb-[40px]">
                <div
                    className="flex lg:flex-row flex-col gap-4 lg:gap-8 justify-between items-start w-full"
                >
                    <div>
                        <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight">
                            Benefits
                        </h2>
                    </div>
                    <div className="lg:max-w-[755px] w-full lg:pt-2">
                        <p className="text-[14px] sm:text-[16px] text-[#49577A] mb-5 sm:mb-6 font-[500] font-graphik">
                            The consultation established a strong foundation for delivering measurable efficiency gains and cost savings, including
                        </p>

                        <ul className="space-y-3.5 sm:space-y-4 w-full pl-1">
                            {[
                                "Operational Efficiency: Reduced loan processing time to under 10 minutes with full traceability across all loans.",
                                "Business Financial Outcome: $2 million in savings with break-even achieved by year two.",
                                "Enhanced Customer Experience: Improved transparency, faster service delivery, and expanded customer reach.",
                                "Workforce Empowerment: Equipped employees with modern tools, driving productivity and self-reliance.",
                            ].map((challenge, index) => (
                                <li key={index} className="flex items-center gap-3 w-full text-[14px] sm:text-[16px] text-[#49577A] font-[500] font-graphik break-words">
                                    <span className="text-[#0F3661] text-[16px] leading-none select-none pt-0.5">•</span>
                                    <span className="flex-1">{challenge}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <CaseStudyBanner />
        </div>
    )
}

export default CaseStudiesDetail
